import { /* createAction, */createReducer } from 'redux-act';

// import { GraphqlErrors } from '../../helpers/GraphqlHelpers'
// import {
//   getServiceProps,
//   reduceService,
//   reduceServiceError,
//   reduceServiceReset,
//   reduceServiceSuccess
// } from '../../helpers/ReduxHelpers'

export var key = 'ApplicationPersonal';

//
// Initial state
//
var initialState = {};

//
// Actions
//
export var actions = {};

//
// Reducer
//
export var reducer = createReducer({}, initialState);

//
// Selectors
//
// const root = (state) => state[key]

export var selectors = {};